import { IMatrix4, IVector3 } from '../../../api.js';
import { SceneObject } from '../../../babylon/SceneObject.js';
import { log_instance } from '../utils/LogInstance.js';
export const OBJECT_DESCRIPTION = {
    type: SceneObject,
    name: 'default-object-description',
    is_enabled: true,
    transform: {
        position: (object) => ({
            get: () => IVector3.copy(object.position),
            set: (val) => { object.position = val; }
        }),
        rotation: (object) => ({
            get: () => IVector3.copy(object.rotation),
            set: (val) => { object.rotation = val; }
        }),
        scale: (object) => ({
            get: () => IVector3.copy(object.scale),
            set: (val) => { object.scale = val; }
        }),
        get_world_transform: (object) => object.get_world_matrix().toIMatrix4ToRef(new IMatrix4()),
        get_parent_world_transform: (object) => object.parent ? object.parent.get_world_matrix().toIMatrix4ToRef(new IMatrix4()) : undefined
    },
    initiate_tabs: [
        {
            tag: 'Scene Object',
            setup: (tab, object) => {
                tab.watch(object, 'id', { is_readonly: true });
                tab.custom.watch('number', {
                    name: 'parent',
                    get: () => { var _a, _b; return (_b = (_a = object.parent) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null; },
                    is_nullable: true
                });
                tab.watch(object, 'receive_shadow');
                tab.button('Dispose', { on_click: () => object.dispose(true) });
                tab.button('Log', { on_click: () => log_instance(object) });
            }
        }
    ]
};
//# sourceMappingURL=SceneObjectDescription.js.map